"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var withStyles_1 = require("../../decorators/withStyles");

var Text_1 = __importDefault(require("../../Text/Text"));

var i18n_1 = require("../../utils/i18n");

var dateUtils_1 = require("../dateUtils");

var DatePicker_styles_1 = require("./DatePicker.styles");

var DatePickerBody =
/** @class */
function (_super) {
  __extends(DatePickerBody, _super);

  function DatePickerBody() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Object.defineProperty(DatePickerBody.prototype, "weekDaysNames", {
    get: function get() {
      var date = new Date(0);
      return dateUtils_1.weekdays.map(function (day, key) {
        date.setDate(4 + day);
        return react_1.default.createElement("td", {
          key: key
        }, react_1.default.createElement(Text_1.default, {
          text: i18n_1.intlConfig.formatDate(date, {
            weekday: 'short'
          }),
          secondary: true
        }));
      });
    },
    enumerable: false,
    configurable: true
  });

  DatePickerBody.prototype.render = function () {
    var _a = this.props,
        children = _a.children,
        classes = _a.classes;
    return react_1.default.createElement("div", {
      className: classes.body
    }, react_1.default.createElement("table", null, react_1.default.createElement("thead", null, react_1.default.createElement("tr", null, this.weekDaysNames)), react_1.default.createElement("tbody", null, children)));
  };

  DatePickerBody = __decorate([withStyles_1.withStyles(DatePicker_styles_1.datePickerBodyStyles)], DatePickerBody);
  return DatePickerBody;
}(react_1.default.Component);

exports.default = DatePickerBody;